export const actionTypePrefix = '@@Comments2';
export const reduxKey = '@@Comments2';
export const actionMenuWidthMobile = 'auto';
export const actionMenuWidthDesktop = 140;
